import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { CartItem } from './cartItem';
import { SingleShipment } from './singleShipment';
import { ChoosePoint } from './steps/shipping/servicePoints';

export const Basket = ({data, setData, shipment, setShipment, error_shipment, setError_Shipment, address, setAddress, getServicePoints, servicePoints, error_buy}) => {

  const navigate = useNavigate()
  const [selected, setSelected] = useState()
  const [openServicePoints, setOpenServicePoints] = useState(false)
  const [openAddress, setOpenAddress] = useState(false)

  return (
    <div className="w-full">
      <div className="bookInfo sm:flex-[1.5] space-y-4">
        <div className="flex justify-between items-end">
          <h2 className="text-xl font-medium">Indkøbskurv</h2>
          <h2 className="text-base font-semibold">{data.length} {data.length === 1 ? "bog" : "bøger"}</h2>
        </div>
        <hr></hr>
        {(error_buy !== '') ?
            <div className="hidden lg:block text-center text-sm w-full py-4 px-2 bg-red-200">
                <p>{error_buy}</p>
            </div>
        :
            ""
        }
        {data.length < 1 ?
          <p className="text-gray-600">Du har ingen bøger i din indkøbskurv</p>
        :
          <div className="space-y-4">
            {shipment.map((ss, index) => {
              return (
                <div id={`ss_${index}`} className="space-y-4 ring-1 ring-neutral-300 p-4">
                  <p className="text-sm">Sælger: <span className="font-medium">{ss.seller.first_name}</span></p>
                  {ss.products.map((book) => {
                    return (
                      <CartItem book={book} setData={setData} />
                    )
                  })}
                  <SingleShipment ss={ss} setShipment={setShipment} setSelected={setSelected} setOpenServicePoints={setOpenServicePoints} error={error_shipment} setError={setError_Shipment} />
                </div>
              )
            })}
          </div>}
      </div>
      <ChoosePoint selected={selected} setShipment={setShipment} openServicePoints={openServicePoints} setOpenServicePoints={setOpenServicePoints} openAddress={openAddress} setOpenAddress={setOpenAddress} address={address} setAddress={setAddress} getServicePoints={getServicePoints} servicePoints={servicePoints} />
    </div>
  )
}